const isMainnet = process.env.IS_MAINNET === "true";
export const MULTICALL_ADDRESS = isMainnet ? '0xcCB3F00bE353950E4C08501ac8Af48765EAAa738' : '0x436C23fE0B44376746abA9B69C77b6eDD2AE1dd7'
export const MULTICALL_ADDRESS_ETH = isMainnet ? '0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696' :'0x1Db1d4ae2cc9F955148B739a3533Dd6B9791f18b'
